import { zodValidator } from '@tanstack/zod-adapter';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { InvitationsPage, type InvitationsSearchState } from '../features/team/team-pages';

const SearchSchema = z.object({
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  search: z.string().trim().max(200).optional().catch(undefined),
  status: z.enum(['PENDING', 'ACCEPTED', 'EXPIRED', 'REVOKED']).optional().catch(undefined),
});

export const Route = createFileRoute('/manage/$companySlug/settings/invitations')({
  component: InvitationsRoute,
  validateSearch: zodValidator(SearchSchema),
});

function InvitationsRoute() {
  const { companySlug } = Route.useParams();
  const searchState: InvitationsSearchState = Route.useSearch();
  const navigate = Route.useNavigate();
  const update = (patch: Partial<InvitationsSearchState>) =>
    void navigate({ search: (previous) => ({ ...previous, ...patch, page: patch.page ?? 1 }) });
  return (
    <InvitationsPage
      companySlug={companySlug}
      onPageChange={(page) => update({ page })}
      onSearchChange={(search) => update({ search })}
      onStatusChange={(status) => update({ status })}
      searchState={searchState}
    />
  );
}
